import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import classnames from 'classnames';
import { actions as modalsActions } from '../../../redux/modals';
import { actions as subscriptionActions } from '../../../redux/subscription';

import Modal from '../../components/Modal';
import ModalHeader from '../../components/ModalHeader';
import ModalButtons from '../../components/ModalButtons';
import SubscriptionDetails from '../../../components/SapiSubscriptionModule/components/SubscriptionDetails';
import { ContainedButton, OutlinedButton } from '../../../components/Buttons';
import { propTypes as i18nPropTypes } from '../../../hocs/intlEquipped';
import { BffFetchContainer } from '../../../containers/FetchContainer';
import Error from '../../../components/Error';
import Icon from '../../../components/Icon';
import mapCancelReason from '../../../util/map-cancel-reason';

const CancelSubscriptionModal = ({
    showModal, showNext, onCancel, onClose, subscriptionData = {}, theme, i18n: { formatMessage },
}) => {
    const [isPending, setIsPending] = useState(false);

    const CANCEL_REASONS_ENDPOINT = `/subscriptions/cancelFlowConfig/${subscriptionData.id}`;

    const handleAction = (cancelFlowConfig = []) => {
        const nextStepIndex = 0;
        const nextStep = cancelFlowConfig[nextStepIndex];

        if (!nextStep) {
            setIsPending(true);
            onCancel(subscriptionData)();
        } else {
            const nextStepProps = {
                onSubmit: onCancel(subscriptionData),
                cancelFlowConfig,
                stepIndex: nextStepIndex,
            };

            showNext(nextStep.type, nextStepProps);
        }
    };

    const renderError = onClickHandlers => (
        <Error
            inline
            onClickHandlers={{
                ...onClickHandlers,
                cancel: onClose,
            }}
        />
    );

    return (
        <Modal
            onClose={ onClose }
            theme={ theme }
            open={ showModal }
        >
            <ModalHeader
                title={ formatMessage('modals.cancelSubscription.header') }
                onClose={ onClose }
            />
            <div className={ theme.cancelSubscriptionModal }>
                <BffFetchContainer endpoint={ CANCEL_REASONS_ENDPOINT } renderError={ renderError } theme={ theme }>
                    { ({ data: cancelFlowConfig }) => (
                        <>
                            <SubscriptionDetails subscription={ subscriptionData } theme={ theme } />
                            <p className={ theme.paragraph }>
                                <FormattedMessage id="modals.cancelSubscription.paragraph" />
                            </p>
                            <ModalButtons theme={ theme }>
                                <ContainedButton
                                    text={ formatMessage('modals.cancelSubscription.buttons.back') }
                                    onClick={ onClose }
                                />
                                <OutlinedButton
                                    onClick={ () => handleAction(cancelFlowConfig) }
                                    disabled={ isPending }
                                    className={ classnames({ [theme.pending]: isPending }) }
                                    text={ formatMessage('modals.cancelSubscription.buttons.stop') }
                                    icon={ isPending ? {
                                        component: () => <Icon theme={ theme } name="loading" />,
                                        position: 'left',
                                    } : {} }
                                    testId="cancelSubscriptionModalBtn"
                                />
                            </ModalButtons>
                        </>
                    ) }
                </BffFetchContainer>
            </div>
        </Modal>
    );
};

CancelSubscriptionModal.propTypes = {
    showNext: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
    subscriptionData: PropTypes.shape({
        status: PropTypes.string,
        name: PropTypes.string,
        bilingDate: PropTypes.string,
        amountDue: PropTypes.shape({
            amount: PropTypes.number,
            currency: PropTypes.string,
        }),
    }).isRequired,
    theme: PropTypes.shape({}),
    showModal: PropTypes.bool.isRequired,
    i18n: i18nPropTypes,
};

const mapDispatchToProps = dispatch => ({
    onCancel: ({ id, source, reactivateFromId }) => (reason = null) => {
        dispatch(subscriptionActions.cancelSubscription(
            `${CONFIG.myPage.apiHost}/subscriptions/${id}/cancel`,
            source,
            mapCancelReason(reason),
            reactivateFromId
        ));
    },
    showNext: (nextStepType, props) => dispatch(modalsActions.showModal(nextStepType, props)),
});

export default connect(null, mapDispatchToProps)(CancelSubscriptionModal);
